import { render, staticRenderFns } from "./savage-widget.vue?vue&type=template&id=03b4d4d0&"
import script from "./savage-widget.ts?vue&type=script&lang=ts&"
export * from "./savage-widget.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "savage-widget.vue"
export default component.exports